/* eslint-disable prettier/prettier */
/** DO NOT EDIT - This file is auto-generated by running `yarn workspace lib-shared-feature-flags update` */
const defaultFeatureFlags = {
    "a-c-forward": false,
    "ada-chat-channel": false,
    "agent-copilot": false,
    "agent-copilot-auto-translate": false,
    "agent-copilot-pin-actions": true,
    "agent-copilot-trial-eligibility": false,
    "agent-offering-with-business-hours": false,
    "agnostic-csat-settings": true,
    "allow-integration-api-token-usage": false,
    "allow-same-origin-in-sandboxed-custom-card-iframe": false,
    "analytics-custom-dashboards": false,
    "authorization-custom-role": false,
    "automation-ai-chatbot-action": false,
    "automation-automation-ai-agent": false,
    "automation-flow-sms-channel": true,
    "automation-flow-whats-app-channel": true,
    "automation-set-custom-attributes": true,
    "automation-trigger-on-conversation-created": true,
    "automation-trigger-on-custom-attribute": true,
    "automation-trigger-on-tag-untag": true,
    "automations": false,
    "automations-oauth": true,
    "call-noise-suppression": false,
    "chatbots-integration-settings": false,
    "collapse-tracking-card-core": false,
    "contact-memories-conversation-view": false,
    "conversation-assistant-for-dixa-messenger": false,
    "conversation-note-mentions": true,
    "conversation-resolution-state": false,
    "conversation-right-sidebar-visibility": false,
    "conversation-value-metric": false,
    "csat-for-dixa-messenger": false,
    "csat-for-email": false,
    "csat-for-widget-chat": false,
    "custom-analytics": true,
    "custom-attributes-in-compose-email": true,
    "custom-away-status": false,
    "custom-form-validation": true,
    "desktop-app-notice-modal": true,
    "digitalgenius-chat-channel": false,
    "dixa-knowledge-integration-for-the-messenger": false,
    "dixa-rewind": false,
    "ecosystem-legacy-shopify-card-creation": false,
    "elevio-suggestions": false,
    "email-channel": true,
    "email-compose-v2": false,
    "email-templates-customization": false,
    "email-translation": true,
    "enable-call-recordings": true,
    "enable-restricted-queues": false,
    "ewt-hide-strategy": false,
    "export-conversations": false,
    "facebook-messenger-channel": true,
    "generic-api-messaging-channel": true,
    "has-bulk-operations": false,
    "has-chat-with-dixa-support": true,
    "has-custom-form-tel-email-fields": false,
    "has-custom-forms-feature": true,
    "has-custom-forms-styling": false,
    "has-messenger": true,
    "help-center": false,
    "inbound-webhooks": true,
    "instagram-management": true,
    "integrations-for-dixa-messenger": false,
    "integrations-for-email": true,
    "integrations-for-phone": true,
    "intent-detection": false,
    "intent-detection-character-limit": 300,
    "kindly-chat-channel": false,
    "knowledge-access": false,
    "knowledge-article-versioning": false,
    "knowledge-articles-ai-auto-translations": false,
    "knowledge-management-nav": false,
    "knowledge-suggestions": false,
    "legacy-presence-sidebar": true,
    "legacy-team-overview": true,
    "message-auto-redaction": false,
    "messenger-form-only-mode-feature": false,
    "mim-automation-variant": false,
    "mim-chatbot": false,
    "mim-conversation-data-source": false,
    "mim-custom-instructions": false,
    "mim-custom-persona": true,
    "mim-duplicate": true,
    "mim-email": false,
    "mim-handovers": false,
    "mim-inline-tools": true,
    "mim-integration-tools": false,
    "mim-procedures": false,
    "mim-tasks": false,
    "mim-test-page": false,
    "mim-wait-user-input": true,
    "mim-web-kb-max-links-access": false,
    "new-whatsapp-onboarding": false,
    "offers-in-chat-conversations": true,
    "organizations-sidebar": false,
    "partner-integrations-datasync": true,
    "partner-integrations-datasync-assembled": true,
    "partner-integrations-widget": true,
    "partner-integrations-widget-braze": true,
    "partner-integrations-widget-github": true,
    "partner-integrations-widget-ingrid": true,
    "partner-integrations-widget-jira": true,
    "partner-integrations-widget-klaviyo": true,
    "partner-integrations-widget-linear": true,
    "partner-integrations-widget-loyaltylion": true,
    "partner-integrations-widget-miuros": false,
    "partner-integrations-widget-recharge": true,
    "partner-integrations-widget-shopify": true,
    "partner-integrations-widget-voyado": true,
    "partner-integrations-widget-yotpo": true,
    "phone-channel": true,
    "presence-sidebar-show-self": true,
    "redact-messages": false,
    "reply-all-toggle-and-config": true,
    "routing-audit-log-automations": false,
    "routing-use-canvas": true,
    "scheduled-conversations": false,
    "shadow-dom-messages": true,
    "shopify-marketplace-app": false,
    "show-tracking-card": true,
    "show-twilio-warn-notifications": false,
    "smart-article-create": false,
    "smart-reply-new-api": false,
    "sms-channel": false,
    "sms-compose": false,
    "spam-filtering": false,
    "subflows-in-dixa-messenger-flow-builder": true,
    "survey-advanced-customization": false,
    "tag-suggestions-enabled": false,
    "teams-assigning-teams-to-queues": false,
    "teams-setting-page-and-assigning-teams-to-queues": false,
    "telephony-numbers-data-residency-regions": false,
    "templates-language-translation-control": false,
    "top-bar-search-quick-actions": true,
    "translate-html": true,
    "translation-hide-original-language": false,
    "trustpilot-channel": true,
    "twitter-channel": false,
    "use-birdeatsbug": false,
    "use-cleaned-up-telephony-middleware": false,
    "use-enable-ios-and-android": false,
    "use-revamped-outbound-call-modal": false,
    "use-shared-worker": true,
    "use-twilio-voice-sdk": true,
    "warm-transfer-to-queue": false,
    "website-data-source": false,
    "whatsapp-channel": true,
    "widget-chat-channel": false,
    "write-html-email": true
};

export { defaultFeatureFlags as default, defaultFeatureFlags };
//# sourceMappingURL=featureFlags.es.js.map
